import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-attendance-sheets',
  templateUrl: './attendance-sheets.component.html',
  styleUrls: ['./attendance-sheets.component.scss']
})
export class AttendanceSheetsComponent implements OnInit {

  AttendanceForm: FormGroup;
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  CourseList: any[] = [];
  filteredListCourse: any[] = [];
  examList: any[] = [];
  filteredListExam: any[] = [];
  BranchList: any[] = [];
  filteredBranchList: any[] = [];
  userPermission: any;
  UserCollege: any = '';
  isDownloading = false;
  dialogRef: MatDialogRef<any>;

  constructor(
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.UserCollege =
      this.userPermission && this.userPermission.length > 0 && this.userPermission[0].CgUi === 'C'
        ? this.userPermission[0].CgId
        : '';

    this.AttendanceForm = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      EmId: new FormControl('', Validators.required),
      Branch: new FormControl({ value: '', disabled: true })
    });

    this.setupExamChangeSubscription();
    this.fetchSession();
  }

  private setupExamChangeSubscription(): void {
    this.AttendanceForm.get('EmId')?.valueChanges.subscribe((examId: string) => {
      if (!examId) {
        this.clearBranch();
        return;
      }

      const exam = this.examList.find((e: any) => e.EmId === examId);

      if (exam && exam.EmStreams === 'Y') {
        this.AttendanceForm.get('Branch')?.enable();
        this.fetchBranches(examId);
      } else {
        this.clearBranch();
      }
    });
  }

  private clearBranch(): void {
    this.BranchList = [];
    this.filteredBranchList = [];
    const branchCtrl = this.AttendanceForm.get('Branch');
    if (branchCtrl) {
      branchCtrl.setValue('');
      branchCtrl.disable();
    }
  }

  // ---------- SESSION ----------
  fetchSession() {
    this.spinner.show();
    const payload: any = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = '';

    this.umsService.getSession(payload).subscribe(
      (res) => {
        this.spinner.hide();
        this.sessionList = [];
        if (res.status) {
          res.data.forEach((element: any) => {
            if (element.SnStatus == 'O') {
              this.sessionList.push(element);
            }
          });
          this.SessionFilterList = this.sessionList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.sessionList = [];
        this.SessionFilterList = [];
      }
    );
  }

  // ---------- COURSE ----------
  getCourse(item: any) {
    this.spinner.show();
    this.CourseList = [];
    this.filteredListCourse = [];
    this.examList = [];
    this.filteredListExam = [];
    this.BranchList = [];
    this.filteredBranchList = [];
    this.AttendanceForm.patchValue({ course: '', EmId: '', Branch: '' });
    this.AttendanceForm.get('Branch')?.disable();

    const payload: any = {};
    payload['SessionId'] = item.SnNo;

    this.umsService.getCourse(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.CourseList = res.data;
          this.filteredListCourse = this.CourseList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    );
  }

  // ---------- EXAM ----------
  getExamList(item: any) {
    this.spinner.show();
    this.examList = [];
    this.filteredListExam = [];
    this.BranchList = [];
    this.filteredBranchList = [];
    this.AttendanceForm.patchValue({ EmId: '', Branch: '' });
    this.AttendanceForm.get('Branch')?.disable();

    const payload: any = {};
    payload['EmCoCode'] = item.CoCode;
    payload['SnNo'] = this.AttendanceForm.get('SessionId')?.value;

    this.umsService.getExam(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.examList = res.data;
          this.filteredListExam = this.examList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.examList = [];
        this.filteredListExam = [];
      }
    );
  }

  // ---------- BRANCHES ----------
  fetchBranches(examId: string): void {
    this.spinner.show();
    const payload = { EmId: examId };

    this.umsService.getExamStream(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status && res.data) {
          this.BranchList = res.data;
          this.filteredBranchList = this.BranchList.slice();

          if (this.BranchList.length > 0) {
            this.AttendanceForm.get('Branch')?.setValue(this.BranchList[0].StrId);
          } else {
            this.AttendanceForm.get('Branch')?.setValue('');
            this.AttendanceForm.get('Branch')?.disable();
          }
        } else {
          this.BranchList = [];
          this.filteredBranchList = [];
          this.AttendanceForm.get('Branch')?.setValue('');
          this.AttendanceForm.get('Branch')?.disable();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.BranchList = [];
        this.filteredBranchList = [];
        this.AttendanceForm.get('Branch')?.setValue('');
        this.AttendanceForm.get('Branch')?.disable();
      }
    );
  }

  // ---------- SHOW BRANCH FIELD ----------
  showBranchField(): boolean {
    const examId = this.AttendanceForm.get('EmId')?.value;
    if (!examId) return false;

    const exam = this.examList.find((e: any) => e.EmId === examId);
    return exam ? exam.EmStreams === 'Y' : false;
  }

  // ---------- VALIDATION ----------
  isDownloadReady(): boolean {
    const form = this.AttendanceForm;
    return !!(
      form.get('SessionId')?.value &&
      form.get('course')?.value &&
      form.get('EmId')?.value
    );
  }

  // ---------- DOWNLOAD ----------
  downloadAttendanceReport() {
    if (!this.isDownloadReady()) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Please select Session, Course and Exam before downloading.',
        title: 'Validation Error',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    this.isDownloading = true;
    this.spinner.show();

    const formData = this.AttendanceForm.value;
    const payload: any = {
      SessionID: formData.SessionId,
      CoCode: formData.course,
      CgCode: this.UserCollege || '',
      EmId: formData.EmId,
      StrId: formData.Branch || '0'
    };

    this.umsService.getAttendanceSheetReport(payload).subscribe(
      (res) => {
        this.spinner.hide();
        this.isDownloading = false;

        if (res.status && res.data && res.data.length > 0) {
          this.exportToExcel(res.data);
        } else {
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: res.message || 'No Data Found',
            title: 'Information',
            icon: 'fas fa-info-circle'
          });
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.isDownloading = false;
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: ERROR.error?.message || 'Failed to fetch attendance report',
          title: 'Error',
          icon: 'fas fa-times'
        });
      }
    );
  }

  // ---------- EXCEL EXPORT ----------
  private exportToExcel(data: any[]) {
    const ws = XLSX.utils.json_to_sheet(data);

    const cols = Object.keys(data[0]).map((key) => {
      const maxLen = Math.max(
        key.length,
        ...data.map(row => (row[key] != null ? row[key].toString().length : 0))
      );
      return { wch: Math.min(maxLen + 2, 60) };
    });
    ws['!cols'] = cols;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Attendance Sheets');

    const now = new Date();
    const datePart =
      `${now.getFullYear()}` +
      `${(now.getMonth() + 1).toString().padStart(2, '0')}` +
      `${now.getDate().toString().padStart(2, '0')}_` +
      `${now.getHours().toString().padStart(2, '0')}` +
      `${now.getMinutes().toString().padStart(2, '0')}`;

    const fileName = `Attendance_Sheets_${datePart}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }
}